/* global google */
import PropTypes from 'prop-types';

import React from 'react';
import ReactDOM from 'react-dom';

import OverlayContext from './OverlayContext';
import {withMap} from './utils';

function GMapsOverlay(map, onDraw) {
  const el = document.createElement('div');
  el.style.position = 'absolute';
  el.style.overflow = 'visible';

  this._el = el;
  this._map = map;
  this._onDraw = onDraw;
  this.setMap(map);

  this._boundsChangedListener = map.addListener('bounds_changed', () => {
    this.draw();
  });
}

GMapsOverlay.prototype = google.maps.OverlayView
  ? new google.maps.OverlayView() : {};

GMapsOverlay.prototype.onAdd = function onAdd() {
  this.getPanes().overlayMouseTarget.appendChild(this._el);
};

GMapsOverlay.prototype.draw = function draw() {
  const bounds = this._map.getBounds();
  if (bounds) {
    const top = bounds.getNorthEast().lat();
    const right = bounds.getNorthEast().lng();
    const bottom = bounds.getSouthWest().lat();
    const left = bounds.getSouthWest().lng();
    const overlayProjection = this.getProjection();

    if (overlayProjection && overlayProjection.fromLatLngToDivPixel) {
      const topLeft = overlayProjection.fromLatLngToDivPixel(
        new google.maps.LatLng({lat: top, lng: left})
      );
      const bottomRight = overlayProjection.fromLatLngToDivPixel(
        new google.maps.LatLng({lat: bottom, lng: right})
      );

      const el = this._el;
      el.style.left = `${topLeft.x}px`;
      el.style.top = `${topLeft.y}px`;
      el.style.width = `${bottomRight.x - topLeft.x}px`;
      el.style.height = `${bottomRight.y - topLeft.y}px`;

      this._onDraw();
    }
  }
};

GMapsOverlay.prototype.onRemove = function onRemove() {
  google.maps.event.clearInstanceListeners(this._boundsChangedListener);
  this._el.parentNode.removeChild(this._el);
  this._el = null;
};

class Overlay extends React.Component {
  static displayName = 'Overlay';

  static propTypes = {
    children: PropTypes.node,
    map: PropTypes.object.isRequired,
  };

  state = {bounds: null};

  componentDidMount() {
    this._overlay = new GMapsOverlay(this.props.map, this._setStateBounds);
    this._el = this._overlay._el;
  }

  componentDidUpdate() {
    if (this._overlay && this._el) {
      ReactDOM.render((
        <OverlayContext bounds={this.state.bounds} positionToPixel={this._positionToPixel}>
          {this.props.children}
        </OverlayContext>
      ), this._el);
    }
  }

  componentWillUnmount() {
    ReactDOM.unmountComponentAtNode(this._el);

    // Set the overlay _onDraw to a noop to prevent setState from being called asyncronously
    // after the component is unmounted
    if (this._overlay) {
      this._overlay._onDraw = () => {};
    }
  }

  _positionToPixel = ({lat, lng}) => {
    const overlayProjection = this._overlay.getProjection();
    if (!overlayProjection || !this.state.bounds) {
      return null;
    }
    const overlayCorner = {lat: this.state.bounds.ne.lat, lng: this.state.bounds.sw.lng};
    const mapCornerPixel = overlayProjection.fromLatLngToDivPixel(
      new google.maps.LatLng(overlayCorner)
    );
    const positionPixel = overlayProjection.fromLatLngToDivPixel(
      new google.maps.LatLng({lat, lng})
    );
    return {
      x: positionPixel.x - mapCornerPixel.x,
      y: positionPixel.y - mapCornerPixel.y,
    };
  };

  _setStateBounds = () => {
    const bounds = this.props.map.getBounds();
    this.setState({bounds: {
      ne: {
        lat: bounds.getNorthEast().lat(),
        lng: bounds.getNorthEast().lng(),
      },
      sw: {
        lat: bounds.getSouthWest().lat(),
        lng: bounds.getSouthWest().lng(),
      },
    }});
  };

  render() {
    return null;
  }
}

export default withMap(Overlay);



// WEBPACK FOOTER //
// ./src/common/components/BetterMap/Overlay.js